import React from 'react';
import styles from './SendingImageLoadingBar.module.css';
import LoadingDots from '../utils/LoadingDots';

interface SendingImageLoadingBarProps {
  image: string | File | Blob;
}

const SendingImageLoadingBar: React.FC<SendingImageLoadingBarProps> = ({ image }) => {
  // Convert blob URL to actual URL if needed
  const imageUrl = typeof image === 'string' 
    ? image 
    : URL.createObjectURL(image);
  
  return (
    <div className={styles.container}>
      <div className={styles.uploadingStamp}>
        <img src={imageUrl} alt="Uploading" />
      </div>
      <div className={styles.uploadingStatus}>
        Sending<LoadingDots />
      </div>
    </div>
  );
};

export default SendingImageLoadingBar; 